<template>
  <div class="outBox" ref="scrollContainer">
    <div>
      <iframe src="http://player.bilibili.com/player.html?aid=583860403&bvid=BV1iz4y1D7S9&cid=210301283&page=1"></iframe>
    </div>

    <div class="videoBox" v-for="(item, index) in list" :key="index" v-if="list.length != 0">
      <div class="videoTop">
        <div style="
            display: flex;
            height: 24px;
            width: 218px;
            justify-content: space-between;
          ">
          <img src="../../assets//video.png" class="video-icon" />
          <p class="videoTitle">{{ item.knowledgeTitle }}</p>
          <img src="../../assets/down.png" class="down-icon" />
        </div>
        <img src="../../assets/line.png" class="videoLine" />
      </div>
      <!-- <img v-if="!queryParam[`played${index}`]" class="image" :src="item.fileUrl" @click="playVideo(index)" />
      <div v-else v-html="getSafeIframeHtml(item.videoFileUrl)" ref="playerContainer" class="player"></div> -->
      <div v-html="getSafeIframeHtml(item.videoFileUrl)" ref="playerContainer" class="player"></div>
    </div>
    <div v-if="loading" class="loading-tip">加载中......</div>
    <div v-if="noMoreData" class="no-more-tip">已加载全部视频</div>
    <div class="noVideo" v-if="list.length == 0">当前无视频教程</div>
  </div>
</template>

<script>
  import { axios } from "@/router/request";
  export default {
    name: "videoList",
    components: {},
    props: {},
    onload() { },
    data() {
      return {
        queryParam: {},
        videoList: [],
        list: [],
        currentPage: 1,
        pageSize: 10,
        loading: false,
        noMoreData: false,
        scrollTimer: null,
        productModelId: "",
        videoData: false,
        BASEURL: "",
        url: "/u058-app-chat/chat/knowledge/reference/queryKnowledgeReferenceByModelId",
      };
    },
    created() {
      if (this.$route.query.productModelId && this.$route.query.BASEURL) {
        this.productModelId = this.$route.query.productModelId;
        this.BASEURL = this.$route.query.BASEURL;
        // this.BASEURL = "https://testapi.yunfenda.com";
        // this.productModelId = "1529021956739960832";
        this.getVideoList();
      } else {
        this.$message({
          showClose: true,
          message: "请求视频列表失败",
          type: "error",
        });
        return;
      }
    },
    mounted() {
      this.$refs.scrollContainer.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.removeEventListener(
          "scroll",
          this.handleScroll
        );
      }
      if (this.scrollTimer) clearTimeout(this.scrollTimer); // 清除定时器
    },
    methods: {
      async getVideoList() {
        if (this.loading || this.noMoreData) return;
        this.loading = true;
        try {
          axios
            .post(this.BASEURL + this.url, {
              page: this.currentPage,
              limit: this.pageSize,
              productModelId: this.productModelId,
            })
            .then((res) => {
              if (res.code === 200) {
                this.list = [...this.list, ...res.data.records];
                console.log("this.list", this.list);
                if (
                  res.data.records.length < this.pageSize &&
                  res.data.total > 0
                ) {
                  this.noMoreData = true;
                }
                this.currentPage++;
              } else {
                console.log("获取视频列表失败");
              }
            });
        } catch (error) {
          console.log("获取视频列表失败", error);
        } finally {
          this.loading = false;
        }
      },
      playVideo(itemId) {
        Object.keys(this.queryParam).forEach((key) => {
          this.queryParam[key] = false;
        });
        this.queryParam[`played${itemId}`] = true;
        this.$forceUpdate();
      },
      getSafeIframeHtml(originalHtml) {
        console.log("originalHtml", originalHtml);
        if (!originalHtml) return "";

        const match = originalHtml.match(/src="([^"]+)"/i);
        if (!match) return originalHtml;
        let src = match[1];
        // 补全协议、避免混合内容警告
        if (src.startsWith("//")) {
          src = "https:" + src;
        }

        // 针对微信小程序webview环境的特殊处理
        if (this.isWeChatMiniProgram()) {
          // 添加微信环境下的兼容参数
          if (!src.includes("isWechatMiniProgram=")) {
            src += (src.includes("?") ? "&" : "?") + "isWechatMiniProgram=1";
          }
          // 确保包含not_redirect参数，防止自动跳转到bilibili
          if (!src.includes("not_redirect=")) {
            src += (src.includes("?") ? "&" : "?") + "not_redirect=1";
          }
          // 添加微信小程序webview兼容的播放器配置
          if (!src.includes("no_banner=")) {
            src += (src.includes("?") ? "&" : "?") + "no_banner=1";
          }
          if (!src.includes("no_title=")) {
            src += (src.includes("?") ? "&" : "?") + "no_title=1";
          }
          if (!src.includes("no_controls=")) {
            src += (src.includes("?") ? "&" : "?") + "no_controls=0";
          }
          if (!src.includes("no_recommend=")) {
            src += (src.includes("?") ? "&" : "?") + "no_recommend=1";
          }
        }

        // 确保包含 autoplay=1（静音自动播放）
        if (!src.includes("autoplay=")) {
          src += (src.includes("?") ? "&" : "?") + "autoplay=1";
        }
        console.log("src", src);
        return `
        <iframe
          src="${src}"
          frameborder="0"
          scrolling="no"
          allowfullscreen
          style="width:100%; height:100%;"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation-by-user-activation"
          referrerpolicy="no-referrer"
        ></iframe>
      `;
      },
      // 检测是否在微信小程序环境
      isWeChatMiniProgram() {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('miniprogram') || ua.includes('microapp') || window.__wxjs_environment === 'miniprogram';
      },
      handleScroll() {
        if (!this.scrollTimer) clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const container = this.$refs.scrollContainer;
          const scrollBottomDistance =
            container.scrollHeight - container.scrollTop - container.clientHeight;
          if (scrollBottomDistance < 20) {
            this.getVideoList();
          }
        }, 500);
      },
    },
  };
</script>
<style scoped>
  .outBox {
    max-height: 95%;
    /* 固定最大高度，让内容超出时出现滚动条 */
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .videoBox {
    position: relative;
    width: 100%;
    height: 214px;
    margin-top: 12px;
  }

  .videoTop {
    padding: 0 10px;
    height: 44px;
    margin-bottom: 12px;
    height: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .video-icon {
    width: 23px;
    height: 24px;
    z-index: 10;
    padding-top: 5px;
  }

  .down-icon {
    width: 20px;
    height: 9px;
    padding-top: 14px;
  }

  .videoTitle {
    height: 24px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23.17px;
    color: rgba(51, 51, 51, 1);
    margin: 0;
    padding-top: 8px;
    z-index: 10;
  }

  .videoLine {
    width: 218px;
    height: 6px;
  }

  .image {
    width: 100%;
    height: 80%;
    position: relative;
    z-index: 10;
    cursor: pointer;
  }

  /* .image {
  width: 100%;
  height: 100%;
  object-fit: cover;
} */
  .player {
    position: relative;
    width: 100%;
    height: 80%;
    object-fit: cover;
    cursor: pointer;
    overflow: hidden;
    z-index: 1;
  }

  .loading-tip,
  .no-more-tip {
    text-align: center;
    padding: 10px;
    color: #999;
  }

  .noVideo {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/views/webview/videoList.vue